import { requestManagerActions } from "../../constants/actionTypes";

const getRequestsList = (data) => {
  return {
    type: requestManagerActions.REQUESTS_LIST_REQUEST,
    payload: data,
  };
};

const setRequestsList = (data) => {
  return {
    type: requestManagerActions.REQUESTS_LIST_SUCCESS,
    payload: data,
  };
};

const setRequestsListErr = (data) => {
  return {
    type: requestManagerActions.REQUESTS_LIST_ERROR,
    payload: data,
  };
};

const clearRequestsList = () => ({
  type: requestManagerActions.REQUESTS_LIST_CLEAR,
});

const deploymentListRequest = (data) => ({
  type: requestManagerActions.DEPLOYMENT_LIST_REQUEST,
  payload: data,
});

const deploymentListSuccess = (data) => ({
  type: requestManagerActions.DEPLOYMENT_LIST_SUCCESS,
  payload: data,
});

const deploymentListError = (data) => ({
  type: requestManagerActions.DEPLOYMENT_LIST_ERROR,
  payload: data,
});

const retrieveRequest = (data) => ({
  type: requestManagerActions.RETRIEVE_REQUEST,
  payload: data,
});

const successRequest = (data) => ({
  type: requestManagerActions.SUCCESS_REQUEST,
  payload: data,
});

const errorRequest = (data) => ({
  type: requestManagerActions.ERROR_REQUEST,
  payload: data,
});

const approveDeclineReq = (data) => {
  return {
    type: requestManagerActions.APPROVE_DECLINE_REQUEST,
    payload: data,
  };
};

const updateReqSuccess = (data) => {
  return {
    type: requestManagerActions.APPROVE_DECLINE_SUCCESS,
    payload: data,
  };
};

const updateReqError = (data) => {
  return {
    type: requestManagerActions.APPROVE_DECLINE_ERROR,
    payload: data,
  };
};

const getTrackRequest = (data) => ({
  type: requestManagerActions.REQUEST_TRACK_REQUEST,
  payload: data,
});

const successTrackRequest = (data) => ({
  type: requestManagerActions.SUCCESS_TRACK_REQUEST,
  payload: data,
});

const errorTrackRequest = (data) => ({
  type: requestManagerActions.ERROR_TRACK_REQUEST,
  payload: data,
});

const retrieveDeploymentJobs = (data) => ({
  type: requestManagerActions.RETRIEVE_DEPLOYMENT_JOBS,
  payload: data,
});

const successDeploymentJobs = (data) => ({
  type: requestManagerActions.SUCCESS_DEPLOYMENT_JOBS,
  payload: data,
});

const errorDeploymentJobs = (data) => ({
  type: requestManagerActions.ERROR_DEPLOYMENT_JOBS,
  payload: data,
});

const removeDeploymentJobs = () => ({
  type: requestManagerActions.REMOVE_DEPLOYMENT_JOBS,
});

const setDeploymentData = (data) => ({
  type: requestManagerActions.SET_DEPLOYMENT_DATA,
  payload: data,
});

const getRequestLabList = (data) => ({
  type: requestManagerActions.GET_REQUEST_LAB,
  payload: data,
});

const setRequestLabList = (data) => ({
  type: requestManagerActions.SUCCESS_REQUEST_LAB,
  payload: data,
});

const errorRequestLabList = (data) => ({
  type: requestManagerActions.ERROR_REQUEST_LAB,
  payload: data,
});

const setRequestTicket = (data) => ({
  type: requestManagerActions.SET_REQUEST_TICKET,
  payload: data,
});

const successRequestTicket = (data) => ({
  type: requestManagerActions.SUCCESS_REQUEST_TICKET,
  payload: data,
});

const errorRequestTicket = (data) => ({
  type: requestManagerActions.ERROR_REQUEST_TICKET,
  payload: data,
});

const setApproveDeclineRequest = (id, data) => ({
  type: requestManagerActions.SET_APPROVE_DECLINE_REQUEST,
  id: id,
  payload: data,
});

const successApproveDeclineRequest = (data) => ({
  type: requestManagerActions.SUCCESS_APPROVE_DECLINE_REQUEST,
  payload: data,
});

const errorApproveDeclineRequest = (data) => ({
  type: requestManagerActions.ERROR_APPROVE_DECLINE_REQUEST,
  payload: data,
});

const getDeleteRequestTicket = (data) => ({
  type: requestManagerActions.REQUEST_DELETE_REQUEST_TICKET,
  payload: data,
});

const successDeleteRequestTicket = (data) => ({
  type: requestManagerActions.SUCCESS_DELETE_REQUEST_TICKET,
  payload: data,
});

const errorDeleteRequestTicket = (data) => ({
  type: requestManagerActions.ERROR_DELETE_REQUEST_TICKET,
  payload: data,
});

const retrieveResendNotification = (data) => ({
  type: requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_REQUEST,
  payload: data,
});

const successRetrieveResendNotification = (data) => ({
  type: requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_SUCCESS,
  payload: data,
});

const errorRetrieveResendNotification = (data) => ({
  type: requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_ERROR,
  payload: data,
});

const requestNotifyAgain = (data) => ({
  type: requestManagerActions.REQUEST_NOTIFY_AGAIN,
  payload: data,
});

const successNotifyAgain = (data) => ({
  type: requestManagerActions.SUCCESS_NOTIFY_AGAIN,
  payload: data,
});

const errorNotifyAgain = (data) => ({
  type: requestManagerActions.ERROR_NOTIFY_AGAIN,
  payload: data,
});

//Export Request
const exportRequestAction = (data) => ({
  type: requestManagerActions.EXPORT_REQUEST_ACTION,
  payload: data,
});
const exportRequestSuccess = (data) => ({
  type: requestManagerActions.EXPORT_REQUEST_SUCCESS,
  payload: data,
});
const exportRequestError = (data) => ({
  type: requestManagerActions.EXPORT_REQUEST_ERROR,
  payload: data,
});
const exportRequestReset = () => ({
  type: requestManagerActions.EXPORT_REQUEST_RESET,
});
const exportRequestLoading = (data) => ({
  type: requestManagerActions.EXPORT_REQUEST_LOADING,
  payload: data,
});

// Bulk Update Request
const bulkUpdateRequestAction = (data) => ({
  type: requestManagerActions.BULK_UPDATE_REQUEST_ACTION,
  payload: data,
});
const bulkUpdateRequestSuccess = (data) => ({
  type: requestManagerActions.BULK_UPDATE_REQUEST_SUCCESS,
  payload: data,
});
const bulkUpdateRequestError = (data) => ({
  type: requestManagerActions.BULK_UPDATE_REQUEST_ERROR,
  payload: data,
});
const bulkUpdateRequestReset = () => ({
  type: requestManagerActions.BULK_UPDATE_REQUEST_RESET,
});
const bulkUpdateRequestLoading = (data) => ({
  type: requestManagerActions.BULK_UPDATE_REQUEST_LOADING,
  payload: data,
});

export {
  getRequestsList,
  setRequestsList,
  setRequestsListErr,
  clearRequestsList,
  deploymentListRequest,
  deploymentListSuccess,
  deploymentListError,
  retrieveRequest,
  successRequest,
  errorRequest,
  getTrackRequest,
  successTrackRequest,
  errorTrackRequest,
  approveDeclineReq,
  updateReqSuccess,
  updateReqError,
  retrieveDeploymentJobs,
  successDeploymentJobs,
  errorDeploymentJobs,
  removeDeploymentJobs,
  setDeploymentData,
  getRequestLabList,
  setRequestLabList,
  errorRequestLabList,
  setRequestTicket,
  successRequestTicket,
  errorRequestTicket,
  setApproveDeclineRequest,
  successApproveDeclineRequest,
  errorApproveDeclineRequest,
  getDeleteRequestTicket,
  successDeleteRequestTicket,
  errorDeleteRequestTicket,
  retrieveResendNotification,
  successRetrieveResendNotification,
  errorRetrieveResendNotification,
  requestNotifyAgain,
  successNotifyAgain,
  errorNotifyAgain,
  exportRequestAction,
  exportRequestSuccess,
  exportRequestError,
  exportRequestReset,
  exportRequestLoading,
  bulkUpdateRequestAction,
  bulkUpdateRequestSuccess,
  bulkUpdateRequestError,
  bulkUpdateRequestReset,
  bulkUpdateRequestLoading
};
